module.exports = __webpack_public_path__ + "assets/img/dadd5a7a5612bf3a674eb1866caeaaff.png";